/* eslint-disable max-lines */
/* tslint:disable:rxjs-finnish */
import { NgZone, Type } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Data,
  Params,
  Route,
  Router,
  UrlSegment
} from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Used for generating observables.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const observableFactory = (data: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return new BehaviorSubject<any>(data);
};

/**
 * Mock an activated route
 */
export class MockActivatedRoute implements ActivatedRoute {
  /**
   * Mock.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paramMap!: Observable<any>;

  /**
   * Mock.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryParamMap!: Observable<any>;

  /**
   * Mock.
   */
  snapshot!: ActivatedRouteSnapshot;

  /**
   * Mock.
   */
  url!: Observable<UrlSegment[]>;

  /**
   * Mock.
   */
  params!: Observable<Params>;

  /**
   * Mock.
   */
  queryParams!: Observable<Params>;

  /**
   * Mock.
   */
  fragment!: Observable<string>;

  /**
   * Mock.
   */
  data!: Observable<Data>;

  /**
   * Mock.
   */
  outlet!: string;

  /**
   * Mock.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component!: Type<any> | null;

  /**
   * Mock.
   */
  routeConfig!: Route;

  /**
   * Mock.
   */
  root!: ActivatedRoute;

  /**
   * Mock.
   */
  parent!: ActivatedRoute;

  /**
   * Mock.
   */
  firstChild!: ActivatedRoute;

  /**
   * Mock.
   */
  children!: ActivatedRoute[];

  /**
   * Mock.
   */
  pathFromRoot!: ActivatedRoute[];

  title!: Observable<string | undefined>;

  /**
   * Mock.
   */
  toString(): string {
    return '';
  }
}

/**
 * Mock an activated route
 */
export const mockActivatedRoute = {
  /**
   * Mock.
   */
  paramMap: observableFactory({}),
  /**
   * Mock.
   */
  queryParamMap: observableFactory({}),
  /**
   * Mock.
   */
  snapshot: {
    paramMap: {
      get: () => ''
    }
  },
  /**
   * Mock.
   */
  url: observableFactory({}),
  /**
   * Mock.
   */
  params: observableFactory({}),
  /**
   * Mock.
   */
  queryParams: observableFactory({}),
  /**
   * Mock.
   */
  fragment: observableFactory({}),
  /**
   * Mock.
   */
  data: observableFactory({}),
  /**
   * Mock.
   */
  outlet: '',
  /**
   * Mock.
   */
  firstChild: {
    url: observableFactory([
      {
        path: 'path1',
        parameters: {}
      },
      {
        path: 'path2',
        parameters: {}
      },
      {
        path: 'path3',
        parameters: {}
      }
    ])
  }
};

/**
 * Wrapper of Angular router (only for testing purpose)
 * Meant to run all router operations within Angular zone
 *  * Keep change detection enabled
 *  * Avoids flooded console with warnings
 *    https://github.com/angular/angular/issues/25837
 *
 * @see Router
 */
export function wrapRouterInNgZone(router: Router, ngZone: NgZone): Router {
  return new Proxy(router, {
    get(target: Router, p: PropertyKey): unknown {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const invokedProperty = (target as any)[p];
      if (typeof invokedProperty !== 'function') {
        return invokedProperty;
      }

      return (...args: Array<unknown>): unknown => {
        return ngZone.run(() => invokedProperty.apply(target, args));
      };
    }
  });
}
